import styled from 'styled-components';
import {Link} from 'react-router-dom';

const StyledSubscriptionIconWithLink = styled(Link)`
  align-items: center;
  border-radius: ${props => props.theme.border_radius.standard};
  color: ${props => props.theme.colors.neutral_10};
  display: flex;
  height: 36px;
  padding: 8px;
  transition: .2s;

  &:hover {
    background-color: ${props => props.theme.colors.neutral_2};
    color: ${props => props.theme.colors.neutral_10};
  }
`;

export {
  StyledSubscriptionIconWithLink,
}
